// "Request Sample" is a thin wrapper over normal messaging: it opens the inbox composer addressed to
// a product's representatives, pre-filled with a canned request body and a marker subject, exactly as
// if a reporter had messaged the product directly. Both fields stay editable once the composer opens.
//
// Mirrors V1's gating: only reporters (media profiles) see it, and only for products that offer
// samples. The button itself is just a MessageButton configured with composeBody/composeSubject.

// Marker subject so a product's reps (and analytics) can recognize a sample-request thread at a glance.
export const sampleRequestSubject = (productName) => `PRODUCT SAMPLE REQUEST | For ${productName}`;

// The canned opening message. Editable once the composer opens — it's only a convenience prefill.
const SAMPLE_REQUEST_BODY_LINES = [
  "Hi!",
  "",
  "I'm writing an article and your product may be suitable for inclusion.",
  "",
  "Could you please send me a sample so I can try it out?",
  "",
  "Thanks!",
];

// The composer body is HTML (contentEditable innerHTML), so render each line as its own block to
// keep the paragraph breaks. Blank lines become an empty block so the spacing survives into the sent
// message. Tags stay within the composer's sanitizer allowlist (div, br).
export const SAMPLE_REQUEST_BODY_HTML = SAMPLE_REQUEST_BODY_LINES.map((line) => `<div>${line || "<br>"}</div>`).join(
  "",
);

// Reporters (media profiles) are the only ones who can request samples — a promoter requesting a
// sample of a product makes no sense, and V1 gated on the reporter user type.
export const viewerIsReporter = () => globalThis.Qwoted?.CURRENT_PROFILE_TYPE === "type_media";

// Whether to surface the Request Sample affordance for a product to the current viewer.
export const canRequestSample = (samplesAvailable) => Boolean(samplesAvailable) && viewerIsReporter();
